const getSite = () => {
  return document.body.dataset.site;
}

export default getSite;